import { memo } from 'react';

import SingleValueFieldIconSVG from '@/assets/single-value-field-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const ISingleValueFieldIcon = (props: Omit<IconProps, 'SVGComponent'>) => (
  <Icon SVGComponent={SingleValueFieldIconSVG} {...props} />
);

export const SingleValueFieldIcon = memo(ISingleValueFieldIcon) as typeof ISingleValueFieldIcon;
